// shared/src/schemas/macro-prediction-outcome.ts
// Zod schema for `macro_prediction_outcomes` table — V2 narrow shape per
// migration 0018_wipe_and_reshape.sql:303-314.
//
// The Phase 6 §K wipe recreated this table with the same shape as
// signal_outcomes (per-observable resolution row keyed by
// (observable_id, horizon, scorer_version)). The pre-§K design that
// emitted `pattern_coherence_verdict` + `classification` + `in_ci_change`
// was abandoned at the V2 reshape — scoring now matches the narrow
// signal-outcomes shape (correct/incorrect/neutral verdict per horizon).
//
// 8 columns: id, observable_id, horizon, realized_value, realized_at,
// outcome, scored_at, scorer_version.

import { z } from 'zod';

// Kept for backwards-compatibility with V1 callers; not enforced at the
// DDL level any longer (the column itself is gone). Treated as legacy.
export const PatternCoherenceVerdictEnum = z.enum([
  'full',
  'partial',
  'incoherent',
  'pending',
]);

export const MacroPredictionClassificationEnum = z.enum([
  'right_on_window',
  'right_late',
  'right_early',
  'wrong_direction',
  'no_signal',
]);

export const MacroPredictionOutcomeSchema = z.object({
  id:              z.string(),
  observable_id:   z.string(),
  horizon:         z.string(),                                          // free-form per V2 DDL CHECK is open
  realized_value:  z.number().nullable(),
  realized_at:     z.string().datetime(),
  outcome:         z.enum(['correct', 'incorrect', 'neutral']),
  scored_at:       z.string().datetime(),
  scorer_version:  z.string(),
});

export type MacroPredictionOutcome = z.infer<typeof MacroPredictionOutcomeSchema>;
